<script>

export default {
  name: 'Btn',
  props: {
    /**
     *  Background color
     */
    color: {
      type: String,
      default: ''
    },
    /**
     *  Size: `normal`, `big`, `giant`
     */
    size: {
      type: String,
      default: 'small'
    },
    /**
     *  Type: `fill`, `stroke`
     */
    type: {
      type: String,
      default: 'fill'
    },
    /**
     *  Flag to disable button
     */
    disabled: null
  },
  methods: {
    click () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}

</script>

<template lang="pug">

button(:class="[ color, size, { disabled }, type ]", @click="click")
  slot

</template>

<style scoped lang="sass">

button
  min-width: 100px
  height: 30px
  border: 0
  color: #FFFFFF
  background: #00B4DB
  background-image: linear-gradient(to right, #00B4DB, #3791C1)
  text-transform: uppercase
  font-size: $small-font-size
  font-weight: $light
  outline: none
  cursor: pointer
  border-radius: 2px
  &.normal
    height: 32px
  &.big
    height: 36px
  &.giant
    height: 54px
  &[disabled], &.disabled
    background: #AAAAAA
  &.stroke
    background: $white
    border: 1px solid #00B4DB
    color: #505050
  &.black
    background: #505050
    color: $white

</style>
